import React from 'react';
import { useI18n, SUPPORTED_LANGUAGES } from '../i18n';

export default function LanguageSwitcher({ className = '' }) {
  const { lang, setLang } = useI18n();

  return (
    <div className={`inline-flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 ${className}`}>
      {SUPPORTED_LANGUAGES.map((l) => {
        const isActive = l.code === lang;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => setLang(l.code)}
            aria-pressed={isActive}
            title={l.label}
            className={`px-2 py-1 rounded-md text-xs font-medium uppercase transition-colors ${
              isActive
                ? 'bg-white text-gray-900 shadow-soft'
                : 'text-gray-500 hover:text-gray-900'
            }`}
          >
            {l.code}
          </button>
        );
      })}
    </div>
  );
}
